export default "__VITE_ASSET__82120130__"